var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.476501,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#ADDFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6364 13.5674C13.7455 13.022 14.0182 12.6402 14.4546 12.2038C15 11.7129 15.2727 11.0038 15.2727 10.2947C15.2727 9.42672 14.9279 8.59429 14.3142 7.98053C13.7004 7.36678 12.868 7.02197 12 7.02197C11.132 7.02197 10.2996 7.36678 9.68585 7.98053C9.0721 8.59429 8.72729 9.42672 8.72729 10.2947C8.72729 10.8402 8.83639 11.4947 9.54548 12.2038C9.92729 12.5856 10.2546 13.022 10.3637 13.5674",
    stroke: "#121622",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3636 15.7492H13.6364",
    stroke: "#121622",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9091 17.9311H13.0909",
    stroke: "#121622",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightbulb);
export default __webpack_public_path__ + "static/media/icon_lightbulb.6b39704979f681af95d3806508efcbdc.svg";
export { ForwardRef as ReactComponent };